/** Unwrap API `{ data: string[] }` or plain arrays for combobox suggestions. */
export function normalizeStringList(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.filter((item): item is string => typeof item === 'string' && item.length > 0)
  }
  if (value && typeof value === 'object' && 'data' in value) {
    return normalizeStringList((value as { data: unknown }).data)
  }
  return []
}
